import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy } from '@angular/core';
import { AssetCardComponent } from '@features/shopping/asset/card/asset-card.component';
import { AssetDetailsResponse } from '@models/asset-details.model';
import { LineAsset } from '@models/dashboard.model';
import { ShoppingCartData, ShoppingCartItem } from '@models/shopping-cart.model';
import { ADDED_FEATURE, REMOVED_FEATURE } from '@models/shopping.model';
import { TranslationPipe } from '@pipes/translation/translation.pipe';
import { ActivityManagerService } from '@services/activity/manager/activity-manager.service';
import { AssetDetailsService } from '@services/asset-details/asset-details.service';
import { PriceSummaryComponent } from '@shared-components/price-summary/price-summary.component';
import { Subject, Subscription } from 'rxjs';
import { DataLoaderService } from 'tangoe-design-system';

import { AddOrRemoveFeaturesComponent } from '../add-or-remove-features/add-or-remove-features.component';

@Component({
  selector: 'ts-manage-features',
  templateUrl: './manage-features.component.html',
  imports: [
    TranslationPipe,
    AssetCardComponent,
    AddOrRemoveFeaturesComponent,
    PriceSummaryComponent
  ]
})
export class ManageFeaturesComponent implements OnDestroy {
  shopping_cart: ShoppingCartData;
  shopping_items_price: ShoppingCartData = {
    shopping_cart_items: [],
    orderTypeId: 0,
    lineId: undefined
  };
  refresh_summary: Subject<boolean> = new Subject<boolean>();
  private subscriptions: Subscription = new Subscription();

  constructor(
    private activity_manager_svc: ActivityManagerService,
    private asset_details_svc: AssetDetailsService,
    private data_loader_svc: DataLoaderService
  ) {}

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  get valid_cart(): ShoppingCartItem[] | undefined {
    return this.shopping_cart?.shopping_cart_items.filter((f: ShoppingCartItem) =>
      [REMOVED_FEATURE, ADDED_FEATURE].includes(f.sub_type!)
    );
  }

  get disable_continue_btn(): boolean {
    return Boolean(
      this.valid_cart?.length && !this.data_loader_svc.isLoading('device-plan-features')
    );
  }

  get navigate_page(): string {
    return `shop/${this.shopping_cart?.orderTypeId}/finalize-order`;
  }

  getShoppingCartData(cart_data: ShoppingCartData): void {
    if (cart_data) {
      this.subscriptions.add(
        this.asset_details_svc.index(cart_data.lineId!, 'asset-item').subscribe({
          next: (res: AssetDetailsResponse) => {
            this.shopping_cart = cart_data;
            this.shopping_cart.existing_asset!.line = {
              ...(cart_data.existing_asset?.line as LineAsset),
              plan: res.asset.line.plan,
              price: res.asset.line.price
            };
            this.shopping_items_price.orderTypeId = cart_data.orderTypeId;
            this.shopping_items_price.lineId = cart_data.lineId;
            this.activity_manager_svc.state().setSteps(res.progress_bar_config?.steps);
          },
          error: (err: HttpErrorResponse) => {}
        })
      );
    }
  }

  updateCartPrice(features: ShoppingCartItem[]): void {
    this.shopping_items_price.shopping_cart_items = features.length
      ? features.map((f: ShoppingCartItem) => ({
          type: f.type,
          id: f.id,
          quantity: f.quantity,
          sub_type: f.sub_type
        }))
      : [];
    this.refresh_summary.next(true);
  }
}
